import styles from "../styles.module.scss";
import localStyles from "./styles.module.scss";
import {useAppData} from "../../context/Contexts";
import {useEffect, useState} from "react";
import {getCurrency, isBundle, isFront, isRear} from "../../helpers/helpers";

declare global {
    interface Window {
        is_real_truck: boolean;
        scs_force_custom?: boolean;
        scs_force_normal?: boolean;
        scs_show_bf_section?: boolean;
        scs_show_earlybf_section?: boolean;
        scs_show_str_section?: boolean;
        scs_show_new_year_promo_section?: boolean;
        scs_bonus_discount?: string;
        scs_bonus_product?: string;
        custom_solution_body?: string;
        scs_show_bonus_section?: boolean;
        scs_custom_title?: string;
        scs_widget_id?: string;
    }
}



export default function StepNav(props) {
    const {currentAppData, setCurrentAppData} = useAppData();

    const [disabled, setDisabled] = useState(true);

    const [product, setProduct] = useState({});

    const [loading, setLoading] = useState(false);

    function getSeatId() {
        const colorSelected = currentAppData?.color;
        if (colorSelected === undefined) {
            return "46996385366308";
        }
        const colorMapping = {
            "Black": "46996385366308",
            "Black & Grey": "47575557144868",
            "Beige": "46996385333540",
            "Wine Red": "49936887021860",
            "Black & Red": "49936887120164",
            "Black & Blue": "49936887087396",
            "Black & White": "49936887054628",
            "Black & Pink": "46996385366308",
            "Tan": "46996385366308",
        }

        if (!colorMapping.hasOwnProperty(colorSelected)) {
            return "46996385366308";
        }

        return colorMapping[colorSelected];
    }

    useEffect(() => {
        const product1 = currentAppData?.product;
        if (product1 && product1.options) {
            setProduct(product1);
        }
    }, [currentAppData.product])

    // const handleBack = () => {
    //     setCurrentAppData(prevState => {
    //         return {...prevState, step: prevState.step - 1}
    //     });
    // }
    const handleNext = async () => {
        if (currentAppData?.step === 3) {
            setLoading(true);
            // console.log(`add to cart\nVehicle: ${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}` +
            //     `\nSeat: ${currentAppData?.seat}` +
            //     `\nColor: ${currentAppData?.color}` +
            //     `\nID: ${currentAppData?.selectedId}` +
            //     `\nAddons: ${currentAppData?.addons || ''}`);

            if (window.is_real_truck) {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                const filteredVariants = currentAppData.product?.variants?.edges.filter((variant) => {
                    return variant.node.id.replace('gid://shopify/ProductVariant/', '') === currentAppData?.selectedId;
                })

                if (!filteredVariants || filteredVariants.length == 0) {
                    alert('No matches');
                    return;
                }
                const selectedVariant = filteredVariants[0];

                const raw = JSON.stringify([
                    {
                        "sku": selectedVariant.node.sku,
                        "name": currentAppData?.product?.title + ' - ' + selectedVariant.node.title,
                        "fitment": `${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model}`,
                        "qty": "1"
                    }
                ]);

                var form = document.createElement("form");
                form.method = "POST";
                form.target = "_parent";
                form.action = "https://realtruck.com/checkout/cart/?3rdParty=seatcoversolutions";
                var element1 = document.createElement("input");
                element1.value = raw;
                element1.name = "body";
                form.appendChild(element1);
                document.body.appendChild(form);

                document.body.appendChild(form);

                form.submit();


                /*var xhr = new XMLHttpRequest();
                var formData = new FormData(form);
                formData.append("body", raw);
                //open the request
                xhr.open('POST','https://realtruck.com/checkout/cart/?3rdParty=seatcoversolutions')
                //xhr.setRequestHeader("Content-Type", "application/json");

                //send the form data
                xhr.send(formData);

                xhr.onreadystatechange = function() {
                    if (xhr.readyState == XMLHttpRequest.DONE) {

                        window.location.href = 'https://realtruck.com/checkout/cart/';
                       // form.reset(); //reset form after AJAX success or do something else
                    }
                }

                form.submit();*/

                /*const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    //redirect: "follow"
                };

                fetch("https://realtruck.com/checkout/cart/?3rdParty=seatcoversolutions", requestOptions)
                    .then((response) => response.text())
                    .then((result) => {
                        console.log(result);
                        window.location.href = 'https://realtruck.com/checkout/cart/';
                    })
                    .catch((error) => console.error(error));*/
                return;
            }

            let has3Bonus = false;
            if (isBundle(currentAppData)) {
                has3Bonus = true;
            } else if (isFront(currentAppData)) {
                has3Bonus = true;
            } else if (isRear(currentAppData)) {
                has3Bonus = true;
            }

            const items: any[] = [];
            const obj1 = {
                quantity: 1,
                id: getSeatCoverId(currentAppData),
                properties: getProperties({
                    _seat: currentAppData.seat,
                    _color: currentAppData.color,
                    'Your Vehicle': `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                    '_your_vehicle': `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim()
                }),
            };
            if (has3Bonus) {
                obj1.properties['_has_bonus'] = has3Bonus;
            }
            items.push(obj1);

            let cc = 'STR09FR';
            if (window.scs_show_new_year_promo_section) {

                const widget_id = window.scs_widget_id ? window.scs_widget_id : "4100206";

                console.log('add for scs_show_new_year_promo_section');
                cc = window.scs_bonus_discount;
                const obj2 = {
                    quantity: 1,
                    id: getSeatId(),
                    discount_code: cc,
                    properties: getProperties({
                        _source: `pdp_multi_step`,
                        _bonus: 'new-year-offer',
                        "_bonus_type": "GWPBonus", "_widget_id": widget_id
                    })
                };
                items.push(obj2);
                if (window.scs_bonus_product) {
                    window.scs_bonus_product.split(',').map((id) => {
                        items.push(getItemObj(id, currentAppData,
                            {_bonus: 'new-year-offer', "_bonus_type": "GWPBonus", "_widget_id": widget_id}));
                    })
                }
                console.log(items);
            } else {
                if (window.scs_show_bf_section) {
                    cc = window.scs_bonus_discount;
                    if (window.scs_bonus_product.indexOf('getSeatId') !== -1) {
                        const obj2 = {
                            quantity: 1,
                            id: getSeatId(),
                            discount_code: cc,
                            properties: getProperties({
                                _source: `pdp_multi_step`,
                            })
                        };
                        items.push(obj2);
                    } else {
                        if (window.scs_bonus_product) {
                            window.scs_bonus_product.split(',').map((id) => {
                                items.push(getItemObj(id, currentAppData,
                                    {"_bonus_type": "GWPBonus", "_widget_id": "4100204"}));
                            })
                        }
                    }

                } else {
                    if (window.scs_show_earlybf_section) {
                        items.push(getItemObj(49714091327780, currentAppData,
                            {"_bonus_type": "GWPBonus", "_widget_id": "4100203"}));
                        items.push(getItemObj(49007184019748, currentAppData,
                            {"_bonus_type": "GWPBonus", "_widget_id": "4100203"}));
                        cc = 'EARLYBFCM';
                    } else {

                        if (isBundle(currentAppData)) {
                            items.push(getItemObj(45340255387940, currentAppData));
                            items.push(getItemObj(49714091327780, currentAppData));
                            items.push(getItemObj(49007184019748, currentAppData));
                        } else if (isFront(currentAppData)) {
                            items.push(getItemObj(45340255387940, currentAppData));
                            items.push(getItemObj(49714091327780, currentAppData));
                        } else if (isRear(currentAppData)) {
                            items.push(getItemObj(45340255387940, currentAppData));
                        }
                    }
                }
            }




            if (currentAppData?.with_bonus) {

                const obj2 = {
                    quantity: 1,
                    id: getSeatId(),
                    discount_code: cc,
                    properties: getProperties({
                        _source: `pdp_multi_step`,
                    })
                };
                items.push(obj2);


            }


            if (currentAppData?.addons === 'Jump Seat Cover') {

                const obj1 = {
                    quantity: 1,
                    id: getJumpSeatCoverId(currentAppData.color),
                    properties: getProperties({
                        _source: `pdp_multi_step`,
                        _seat: currentAppData.seat,
                        _color: currentAppData.seat,
                        'Your Vehicle': `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim(),
                        '_your_vehicle': `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`.trim()
                    }),
                };
                items.push(obj1);
            }

            var data = {
                items: items,
            };
            // loadingOverlay($(".cart-container form"), "show");

            fetch("/cart/add.js", {
                method: "POST",
                body: JSON.stringify(data),
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With":
                        "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
                },
            })
                .then((response) => response.json())
                .then((resp) => {
                    // Do something with the resp
                    // console.log("updated");

                    if (currentAppData?.with_bonus || window.scs_show_earlybf_section
                        || window.scs_show_bf_section
                        || window.scs_show_str_section
                        || window.scs_show_new_year_promo_section) {
                        //fetch(`/discount/${cc}`)
                        fetch(`/checkout?discount=${cc}`)
                            .then(function () {

                                // After the discount code has been applied, force the cart to update so the discount is visible instantly
                                setTimeout(function () {
                                    fetch('/cart/update.js', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({
                                            updates: {},
                                        }),
                                    }).then(function () {
                                        setLoading(false);
                                    });
                                }, 500)

                            })
                            .catch(function (error) {
                                console.error('Error:', error);
                                setLoading(false);

                                setTimeout(function () {
                                    fetch('/cart/update.js', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({
                                            updates: {},
                                        }),
                                    }).then(function () {
                                        setLoading(false);
                                    });
                                }, 500)
                            });
                    } else {
                        setLoading(false);
                    }
                })
                .catch(function (error) {
                    // console.log("Request failed", error);
                    setLoading(false);
                });

        } else {
            if (currentAppData?.step === 1) {
                if (!currentAppData.year || !currentAppData.make || !currentAppData.model) {
                    alert(`Please select your vehicle`);
                    return;
                }
                setTimeout(function () {
                    setCurrentAppData(prevState => {
                        return {...prevState, step: prevState.step + 1, seat: ''}
                    });
                    setTimeout(function () {
                        if (window.innerWidth < 768) {
                            const element = document.getElementById('step_2');
                            element?.scrollIntoView({
                                behavior: 'smooth'
                            });
                        }
                    }, 50)
                }, 100)

                return;
            }

            setTimeout(function () {
                if (currentAppData?.step === 2) {
                    if (window.innerWidth < 768) {
                        const element = document.getElementById(`${styles.step_3}`);
                        element?.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                }
            }, 200);

            setCurrentAppData(prevState => {
                return {...prevState, step: prevState.step + 1}
            });
        }
    }
    useEffect(() => {
        // console.debug('StepNav: ', currentAppData);
        if (currentAppData?.step === 1) {

            if (currentAppData?.check) {
                if (currentAppData?.year && currentAppData.make !== '' && currentAppData.model !== '') {
                    // console.log('d1');
                    // console.log('trim', currentAppData?.trim);
                    // console.log('has_trims', currentAppData?.has_trims);
                    setDisabled(currentAppData?.has_trims && (!currentAppData?.trim || currentAppData?.trim === ''));
                } else {
                    // console.log('d2');
                    setDisabled(true);
                }
            } else {
                // console.log('d3');
                setDisabled(true);
            }
        }
        if (currentAppData?.step === 2) {
            if (currentAppData.seat != '') {
                // console.log('d4');
                setDisabled(false);
            } else {
                // console.log('d5');
                setDisabled(true);
            }
        }
        if (currentAppData?.step === 3) {
            if (currentAppData.color != '') {
                // console.log('d6');
                setDisabled(false);
            } else {
                // console.log('d7');
                setDisabled(true);
            }
        }
    }, [currentAppData.check, currentAppData.step,
        currentAppData.make, currentAppData.model, currentAppData.year,
        currentAppData.trim, currentAppData.has_trims,
        currentAppData.seat, currentAppData.color]);


    return (<>
        <section className={`${localStyles.section__step_nav}`} id={`step_nav`}>
            {/*{currentAppData.step > 1 ?
                <button onClick={handleBack} className={`${localStyles.back}`}>Back</button> : ''}*/}
            <button onClick={handleNext} disabled={disabled || loading}
                    className={`${styles.btn} ${loading ? localStyles.loading : ''}`}>
                {loading ? <span className={`${localStyles.loader}`}></span> : ''}
                {currentAppData?.step && currentAppData?.step < 3
                    ? (<span className={`${styles.btn_inner}`}>Next Step  <svg width="10" height="15"
                                                                               viewBox="0 0 10 15"
                                                                               fill="none"
                                                                               xmlns="http://www.w3.org/2000/svg">\n' +
                '<path d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                       fill="white"/>\n' +
                '</svg></span>) : (
                        <span className={`${styles.btn_inner}`}>Add To Cart <svg width="10" height="15"
                                                                                 viewBox="0 0 10 15"
                                                                                 fill="none"
                                                                                 xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                            fill="white"/>
                    </svg>
                </span>)}</button>
        </section>
    </>);
}


function getJumpSeatCoverId(colorId) {

    const colorToJumpSeatCover = {
        'Black': 49988033872164,
        'Brown': 49988033904932,
        'Grey': 49988033937700,
        'Beige': 49988033970468,
        'Wine Red': 49988034003236,

    };

    return typeof colorToJumpSeatCover[colorId] !== 'undefined' ? colorToJumpSeatCover[colorId] : colorToJumpSeatCover['Black'];
}

function getItemObj(id, currentAppData, defaultProps = {}): any {
    const newProps = {
        _seat: currentAppData.seat,
        _color: currentAppData.color,
        _bonus: "exclusive_sale"
    };
    const objb1 = {
        quantity: 1,
        id: id,
        properties: {...newProps, ...defaultProps}
    }
    return objb1;
}

function getProperties(params: { _source: string; _bonus: string; _bonus_type: string; _widget_id: string }) {
    const newParams = {
    };
    if (window.sessionStorage.getItem('attribution')) {
        newParams._scs_attribution = window.sessionStorage.getItem('attribution');
    }
    if (window.sessionStorage.getItem('utm_source')) {
        newParams._scs_utm_source = window.sessionStorage.getItem('utm_source');
    }
    if (window.sessionStorage.getItem('utm_campaign')) {
        newParams._scs_utm_campaign = window.sessionStorage.getItem('utm_campaign');
    }
    if (window.sessionStorage.getItem('utm_medium')) {
        newParams._scs_utm_medium = window.sessionStorage.getItem('utm_medium');
    }

    return {...params, ...newParams};
}

function getSeatCoverId(currentAppData) {
    if (currentAppData && currentAppData?.check) {
        if (currentAppData?.check.availability
            && currentAppData?.check.availability[currentAppData?.seat]
            && currentAppData?.check.availability[currentAppData?.seat]['prekit']
            && currentAppData?.check.availability[currentAppData?.seat]['prekit'][currentAppData?.color]
        ) {
            return currentAppData?.check.availability[currentAppData?.seat]['prekit'][currentAppData?.color]['id'];
        }
    }

    return currentAppData?.selectedId;
}